import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Custom Components
import ModelTable from "UI/Table/ModelTable";
import TableCard from "UI/Table/TableCard";
import TableCardContent from "UI/Table/TableCardContent";
import DialogContext from "UI/DialogContext/DialogContext";
import PredlozakCjenikaDialog from "./PredlozakCjenikaDialog";

import model from "Models/vozilaCjenici";
import dataController from "Lib/dataController";

import UserContext from "Components/UserContext/UserContext";
import SnackbarContext from "UI/SnackbarContext/SnackbarContext";

function PredlosciCjenikaTable(props) {
  const dialogContext = useContext(DialogContext);
  const userContext = useContext(UserContext);
  const snackbarContext = useContext(SnackbarContext);

  const { t } = useTranslation();
  const [records, setRecords] = useState([]);

  const dc = new dataController(model, "prijevoznici/" + userContext.subjectId + "/predlosci-cjenika");

  useEffect(() => {
    refreshRecords();
  }, [userContext.subjectId]);

  const handleEdit = (evt, sel) => {
    const selId = parseInt(sel[0], 10);
    const record = records[selId];

    dialogContext.showDialog(PredlozakCjenikaDialog, {
      dc: dc,
      form: "predlozak",
      recordId: record.id,
      onClose: handleDialogClose,
      mode: "update"
    });
  };

  const handleAdd = () => {
    dialogContext.showDialog(PredlozakCjenikaDialog, {
      dc: dc,
      form: "predlozak",
      onClose: handleDialogClose,
      mode: "insert"
    });
  };

  const handleDialogClose = (result) => {
    if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    dc.GetData().then((resp) => {
      if (resp.success) {
        setRecords(resp.data || []);
      }
    }).catch((result) => {
      snackbarContext.showNotification(result.error, "error");
    });
  };

  const handleRowAction = function(action, id) {
    if (action === "edit") {
      dialogContext.showDialog(PredlozakCjenikaDialog, {
        dc: dc,
        form: "predlozak",
        recordId: id,
        onClose: handleDialogClose,
        mode: "update"
      });
    }
  }

  const allowRowAction = function(action, id) {
    return true;
  }

  return (
    <TableCard>
      <TableCardContent>
        <ModelTable
          title={t("titles.predlosci_cjenika")}
          records={records}
          dc={dc}
          allowExport={true}
          allowFilter={true}
          allowAdd={true}
          addLabel={t("buttons.new_m")}
          allowSelection="none"
          handleAdd={handleAdd}
          viewName="predlosci"
          tableName="CBC_Predlosci_cjenika"
          onRowAction={handleRowAction}
          allowRowAction={allowRowAction}
          onDoubleClick={(id) => handleRowAction("edit", id)}
          handleRefresh={refreshRecords}
        >
          {/* <TableButtonEdit onClick={handleEdit} /> */}
        </ModelTable>
      </TableCardContent>
    </TableCard>
  );
}

export default PredlosciCjenikaTable;
